// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var LongTextDefaultForm$ReactHooksTemplate = require("./LongTextDefaultForm.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");

function LongTextForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var longText = props.longText;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined || value.trim() === "") {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, undefined));
    } else {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, value));
    }
  };
  var match = LongText$ReactHooksTemplate.representation(longText);
  var backGroundCss;
  switch (match) {
    case "NoBackground" :
    case "TropicalBreezeBackground" :
        backGroundCss = "bg-tropicalbreeze";
        break;
    case "BlackBackground" :
        backGroundCss = "bg-black bg-opacity-50 text-white";
        break;
    
  }
  var match$1 = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match$1) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(LongTextDefaultForm$ReactHooksTemplate.make, {
                  longText: longText,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: LongText$ReactHooksTemplate.getTextTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: LongText$ReactHooksTemplate.getDescriptionTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsx("p", {
                      children: JsxRuntime.jsx("textarea", {
                            className: backGroundCss + " h-127-px overflow-x-hidden\n            w-full outline-none focus:ring rounded-lg p-2 ",
                            maxLength: 3500,
                            placeholder: LongText$ReactHooksTemplate.getPlaceholderTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                            rows: 5,
                            value: Belt_Option.getWithDefault(LongText$ReactHooksTemplate.answer(longText), ""),
                            onChange: handleOnchange
                          }),
                      className: "flex flex-wrap pb-8 w-full"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col py-8 px-16 small:px-6"
            });
}

var make = LongTextForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
